/**
 * Title Case for display only: uppercases the first letter of each whitespace-separated word,
 * skipping leading punctuation ("(us)" gives "(Us)"). A word that starts with a digit is left
 * alone ("2nd" stays "2nd"), and hyphens are not word breaks. Everything else stays as typed. This
 * is CSS `text-transform: capitalize`, so the canvas preview matches the DOM face.
 *
 * Never use the result as a line item property value — those carry exactly what the customer typed.
 *
 * @param text - The text to display.
 * @returns The text with each word's first letter uppercased.
 */
export function capitaliseWords(text: string): string {
  return text.replace(
    /(^|\s)([^\p{L}\p{N}\s]*)(\p{L})/gu,
    (_match, boundary: string, punctuation: string, first: string) => boundary + punctuation + first.toUpperCase(),
  )
}
